module.exports = __webpack_public_path__ + "img/index7.4e23ac79.png";